import gql from 'graphql-tag';

const GET_ALL_TAX = gql`
  query {
    getAllTax {
      taxId
      name
      integrated
      rates {
        rateId
        name
        rateValue
      }
    }
  }
`;

const GET_ALL_TAX_LIST = gql`
  query getTaxList($listInfo: ListInfoInput) {
    getTaxList(listInfo: $listInfo) {
      taxes {
        taxId
        name
        integrated
        totalRate
      }
      listInfo {
        hasMore
        page
        pageSize
        totalCount
        sort {
          attribute
          order
        }
      }
    }
  }
`;

const GET_TAX = gql`
  query getTax($taxId: ID!) {
    getTax(taxId: $taxId) {
      taxId
      name
      integrated
      totalRate
      rates {
        rateId
        name
        rateValue
      }
    }
  }
`;

export { GET_ALL_TAX, GET_ALL_TAX_LIST, GET_TAX };
